import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import { getCurrentSiteId } from '../../site/selectors';

import {
  ACTION_LOAD_SITE_GOOGLE_ANALYTICS__REQUEST,
  ACTION_LOAD_SITE_GOOGLE_ANALYTICS__SUCCESS,
  ACTION_LOAD_SITE_GOOGLE_ANALYTICS__FAIL,
} from '../actionTypes';


export const actionLoadSiteGoogleAnalyticsSuccess = siteGoogleAnalytics => ({
  type: ACTION_LOAD_SITE_GOOGLE_ANALYTICS__SUCCESS,
  payload: { siteGoogleAnalytics },
});

export const actionLoadSiteGoogleAnalyticsFail = error => ({
  type: ACTION_LOAD_SITE_GOOGLE_ANALYTICS__FAIL,
  payload: { error },
});

export const actionLoadSiteGoogleAnalyticsRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_SITE_GOOGLE_ANALYTICS__REQUEST,
    });

    return apiClientHelper.get(
      `/rest/webmaster/site/analytics_script/${getCurrentSiteId(getState())}`
    ).then(
      siteGoogleAnalytics => {
        dispatch(actionLoadSiteGoogleAnalyticsSuccess(siteGoogleAnalytics));
      },
      error => {
        dispatch(actionLoadSiteGoogleAnalyticsFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
